import React, { useState, useEffect } from 'react';
import LoadingIndicator from '../../../../../setup/Loader/LoaderIndicator';
import { subscriptionAutoRenew, userSubscription, setSubscription } from '../../../AxiosRtk/Settings';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import useSubscription from '../../../../customHooks/subscriptionProvider';
import { isEmpty } from 'lodash';
import { constant } from '../../../../../utils/constant';

export function SubscriptionExpiryInfo({ getLangTranslation }) {
    const {
        isSubscriptionExpired,
        noSubscriptionIsTrialPeriodExpired
    } = useSubscription();
    if (isSubscriptionExpired()) {
        return (
            <div
                className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6" role="alert"
            >
                <i className='icon-info fs-4' /> {getLangTranslation("SUBSCRIPTION_EXPIRED_ERROR", "Your subscription is expired")}
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                ></button>
            </div>
        )
    }

    if (noSubscriptionIsTrialPeriodExpired()) {
        return (
            <div
                className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6" role="alert"
            >
                <i className='icon-info fs-4' /> {getLangTranslation("SUBSCRIPTION_YOU_HAVE_USED_YOUR_TRIAL_PERIOD", "You have used your trial period")}
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                ></button>
            </div>
        )
    }

    return null;
}

export function SubscriptionDayRemainingInfo({ subscription, trialPeriodData, getLangTranslation }) {

    const {
        getSubscriptionDetails,
        getTrialDataDetails,
        isSubscriptionCardDetailLoding
    } = useSubscription();

    function getPlan(subscription) {
        const totalDays = subscription?.totalDays;
        return `${totalDays ?? 0} days`
    }

    function getProgressBarPercentage(subscription) {
        const percentage = Math.floor((subscription?.minuteRemaining * 100) / (subscription?.totalDays * 24 * 60))
        return `${percentage}%`
    }


    if (isSubscriptionCardDetailLoding()) {
        return (
            <div className='card'>
                <div className='card-body'>
                    <LoadingIndicator height={20} width={100} color={constant?.color?.DODGER_BLUE} />
                </div>
            </div>
        )
    }

    if (subscription && subscription !== 'DATA_NOT_FOUND') {
        return (
            <div className="d-flex align-items-center gap-3">
                <span className="icon-wrap icon-blue">
                    <i className="icon-mobile"></i>
                </span>
                <div className="flex-grow-1">
                    <p className="d-flex justify-content-between mb-3">{getSubscriptionDetails(subscription)} <span> {getPlan(subscription)}</span></p>
                    <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div className="progress-bar" style={{ width: getProgressBarPercentage(subscription) }}></div>
                    </div>
                </div>
            </div>
        )
    } else if (subscription === 'DATA_NOT_FOUND' && trialPeriodData) {
        return (
            <div className="d-flex align-items-center gap-3">
                <span className="icon-wrap icon-blue">
                    <i className="icon-mobile"></i>
                </span>
                <div className="flex-grow-1">
                    <p className="d-flex justify-content-between mb-3">
                        {getTrialDataDetails(trialPeriodData)}
                        <span> {getPlan(trialPeriodData)} </span>
                    </p>
                    <div
                        className="progress"
                        role="progressbar"
                        aria-label="Basic example"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    >
                        <div className="progress-bar" style={{ width: getProgressBarPercentage(trialPeriodData) }}></div>
                    </div>
                </div>
            </div>
        )
    }

    return null

}

export function SubscriptionAutoRenew({ subscription, getLangTranslation }) {
    const [autoRenewChecked, setAutoRenewChecked] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!subscription) {
            setAutoRenewChecked(false);
        } else {
            setAutoRenewChecked(subscription?.IsAutoRenew === 1 ? true : false)
        }
    }, [subscription])

    function handleAutoRenew(checked) {
        setAutoRenewChecked(checked);
        const payload = {
            subscriptionId: subscription?.StripeSubscriptionId,
            isAutoRenewal: checked
        };

        subscriptionAutoRenew(payload)
            .then((res) => {
                userSubscription()
                    .then((res) => {
                        dispatch(setSubscription(res?.data?.result))
                    })
                    .catch((err) => {
                        console.log("user subscritpion catch error ===>>>", err?.response?.data?.message)
                    })
            })
            .catch((err) => {
                console.log("subscritpion auto renew catch error ===>>>", err?.response?.data?.message)
            })
    }

    if (subscription?.StripeCustomerId) {
        return (
            <div className="form-check form-switch mx-auto mb-6">
                <input
                    className="form-check-input pt-cursor"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    checked={autoRenewChecked}
                    onChange={(e) => handleAutoRenew(e.target.checked)}
                />
                <label className="form-check-label pt-cursor" htmlFor="flexSwitchCheckDefault">{getLangTranslation('SUBSCRIPTION_AUTO_RENEW', 'Auto renew')}</label>
            </div>
        )
    }

    return null;
}

export function SubscribtionCardDetails({ subscription, trialPeriodData, getLangTranslation }) {
    const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
    const { appLanguageId } = useSelector(({ misc }) => misc);
    const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);
    function reverseString(str) {
        return [...str].reverse().join("");
    }
    const { isSubscriptionCardDetailLoding } = useSubscription();
    if (isSubscriptionCardDetailLoding()) {
        return (
            <div className='content-300 mb-6'>
                <div className='card'>
                    <div className='card-body'>
                        <LoadingIndicator height={20} width={100} color={constant?.color?.DODGER_BLUE} />
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className='content-300 mb-6'>
            <div className='card'>
                {
                    !isEmpty(subscription) && subscription !== 'DATA_NOT_FOUND' ? (
                        <div className='card-body'>
                            <span className='text-small text-gray text-uppercase'>
                                {getLangTranslation('SUBSCRIPTION_KIDO_UNLIMITED_DEVICE', 'Kido unlimited devices')} {subscription?.interval ? subscription?.interval : 0} {subscription?.planType}
                            </span>
                            <h5 className='text-blue-900 my-4'>{getLangTranslation('SUBSCRIPTION_PREMIUM_MEMBERSHIP', 'Premium Membership')}</h5>
                            <ul className={`list-unstyled mb-0 ${ lang?.isRTL === 1 ? 'pe-0' : ''}`}>
                                <li className='d-flex align-items-center gap-2 mb-2'>
                                    <label className='text-small text-gray'>{getLangTranslation('SUBSCRIPTION_SUBSCRIPTION_DATE', 'Subscription Date')}:</label>
                                    <p className='text-small text-blue-900 mb-0'>{
                                        moment.unix(subscription?.StartDate).utcOffset(subscription?.timezone_offset).locale('en').format("DD MMM YYYY HH:mm")
                                    }</p>
                                </li>
                                <li className='d-flex align-items-center gap-2 mb-2'>
                                    <label className='text-small text-gray'>{getLangTranslation('SUBSCRIPTION_END_OF_SUBSCRIPTION', 'End of subscription')}:</label>
                                    <p className='text-small text-blue-900 mb-0'>{moment.unix(subscription?.EndDate).utcOffset(subscription?.timezone_offset).locale('en').format("DD MMM YYYY HH:mm")}</p>
                                </li>
                                <li className='d-flex align-items-center gap-2 mb-2'>
                                    <label className='text-small text-gray'>{getLangTranslation('SUBSCRIPTION_TRANSACTION_CODE', 'Transaction code')}:</label>
                                    <p className='text-small text-blue-900 text-break mb-0'>{reverseString(reverseString(subscription?.TransactionCode).slice(0, 16))}</p>
                                </li>
                                <li className='d-flex align-items-center gap-2 mb-2'>
                                    <label className='text-small text-gray'>{getLangTranslation('SUBSCRIPTION_DISCOUNT_FROM_NEXT_PAYMENT', "Discount from next payment")}:</label>
                                    <p className='text-small text-blue-900 mb-0'>{subscription?.DiscountAmount || '0'}%</p>
                                </li>
                            </ul>
                        </div>
                    ) : (
                        <div className='card-body'>
                            <span className='text-small text-gray text-uppercase'>
                                {trialPeriodData?.secondRemaining <= 0 && getLangTranslation('SUBSCRIPTION_KIDO_SUBSCRIPTION_REQUIRED', 'Subscription required')}
                            </span>
                            <h5 className='text-blue-900 my-4'>
                                {getLangTranslation('SUBSCRIPTION_KIDO_UNLIMITED_DEVICES_DURATION_SUBSCRIPTION_TYPE', 'Unlimited devices $DURATION$ $SUBSCRIPTION_TYPE$')?.replace("$DURATION$", '')?.replace("$SUBSCRIPTION_TYPE$", '')}  {(
                                    moment
                                        .utc(trialPeriodData?.ReferralEnd)
                                        .diff(
                                            moment.utc(
                                                trialPeriodData?.ReferralStart
                                            ),
                                            "days"
                                        ) / 30
                                )
                                    .toString()
                                    .includes(".")
                                    ? (
                                        moment
                                            .utc(
                                                trialPeriodData?.ReferralEnd
                                            )
                                            .diff(
                                                moment.utc(
                                                    trialPeriodData?.ReferralStart
                                                ),
                                                "days"
                                            ) / 30
                                    )
                                        .toString()
                                        .slice(
                                            0,
                                            (
                                                moment
                                                    .utc(
                                                        trialPeriodData?.ReferralEnd
                                                    )
                                                    .diff(
                                                        moment.utc(
                                                            trialPeriodData?.ReferralStart
                                                        ),
                                                        "days"
                                                    ) / 30
                                            )
                                                .toString()
                                                .indexOf(".")
                                        )
                                    : (
                                        moment
                                            .utc(
                                                trialPeriodData?.ReferralEnd
                                            )
                                            .diff(
                                                moment.utc(
                                                    trialPeriodData?.ReferralStart
                                                ),
                                                "days"
                                            ) / 30
                                    ).toString()}{" "}
                                {getLangTranslation('SETTING_SUBSCRIPTION_MONTH', 'month')}{" "}
                                {moment
                                    .utc(trialPeriodData?.ReferralEnd)
                                    .diff(
                                        moment.utc(
                                            trialPeriodData?.ReferralStart
                                        ),
                                        "days"
                                    ) %
                                    30 >
                                    0
                                    ? (moment
                                        .utc(
                                            trialPeriodData?.ReferralEnd
                                        )
                                        .diff(
                                            moment.utc(
                                                trialPeriodData?.ReferralStart
                                            ),
                                            "days"
                                        ) %
                                        30) + " " +
                                    getLangTranslation("SETTING_SUBSCRIPTION_DAYS", "days")
                                    : null}</h5>
                            {
                                !isEmpty(trialPeriodData) && (
                                    <ul className={`list-unstyled mb-0 ${ lang?.isRTL === 1 ? 'pe-0' : ''}`}>
                                        <li className='d-flex align-items-center gap-2 mb-2'>
                                            <label className='text-small text-gray'>
                                                {getLangTranslation("SUBSCRIPTION_TRIAL_PERIOD_HAS_BEEN_UPDATED", "Trial period updated")?.replace("updated", moment
                                                    .utc(trialPeriodData?.ReferralEnd)
                                                    .diff(
                                                        moment.utc(
                                                            trialPeriodData?.ReferralStart
                                                        ),
                                                        "days"
                                                    )) + " " + getLangTranslation("SETTING_SUBSCRIPTION_DAYS", "days")}
                                            </label>
                                        </li>
                                        <li className='d-flex align-items-center gap-2 mb-2'>
                                            <label className='text-small text-gray'>{getLangTranslation('SUBSCRIPTION_SUBSCRIPTION_DATE', 'Subscription Date')}:</label>
                                            <p className='text-small text-blue-900 mb-0'>{
                                                moment(trialPeriodData?.ReferralStart).utcOffset(trialPeriodData?.timezone_offset).locale('en').format("DD MMM YYYY HH:mm")
                                            }</p>
                                        </li>
                                        <li className='d-flex align-items-center gap-2 mb-2'>
                                            <label className='text-small text-gray'>{getLangTranslation('SUBSCRIPTION_END_OF_SUBSCRIPTION', 'End of subscription')}</label>
                                            <p className='text-small text-blue-900 mb-0'>{moment(trialPeriodData?.ReferralEnd).utcOffset(trialPeriodData?.timezone_offset).locale('en').format("DD MMM YYYY HH:mm")}</p>
                                        </li>
                                        <li className='d-flex align-items-center gap-2 mb-2'>
                                            <label className='text-small text-gray'>{getLangTranslation('SUBSCRIPTION_DISCOUNT_FROM_NEXT_PAYMENT', 'Discount from next payment')}:</label>
                                            <p className='text-small text-blue-900 mb-0'>{trialPeriodData?.DiscountAmount || '0'}%</p>
                                        </li>
                                    </ul>
                                )
                            }
                        </div>
                    )
                }
            </div>
        </div>
    )

}

const MySubscriptionPlan = ({ subscription, trialPeriodData, getLangTranslation }) => {
    return (
        <>
            <SubscriptionExpiryInfo
                getLangTranslation={getLangTranslation}
            />
            <SubscribtionCardDetails
                subscription={subscription}
                trialPeriodData={trialPeriodData}
                getLangTranslation={getLangTranslation}
            />
            <SubscriptionAutoRenew
                subscription={subscription}
                getLangTranslation={getLangTranslation}
            />
            <SubscriptionDayRemainingInfo
                subscription={subscription}
                trialPeriodData={trialPeriodData}
                getLangTranslation={getLangTranslation}
            />
        </>
    )
}

export default MySubscriptionPlan